var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.95,
    height: 50.736,
    viewBox: "0 0 61.95 50.736",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3012",
    "data-name": "Grupo 3012",
    transform: "translate(-522.788 -235.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2499",
    "data-name": "Trazado 2499",
    d: "M574.463,289.857H561.685l-6.38,7.722a2.362,2.362,0,0,1-3.691-.062l-5.906-7.659H533.063a10.275,10.275,0,0,1-10.275-10.275V257.975A10.275,10.275,0,0,1,533.063,247.7h41.4a10.275,10.275,0,0,1,10.274,10.275v21.608A10.275,10.275,0,0,1,574.463,289.857Z",
    transform: "translate(0 -12)",
    fill: "#784dec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3011",
    "data-name": "Grupo 3011",
    transform: "translate(539.376 244.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2500",
    "data-name": "Trazado 2500",
    d: "M938.408,480.731l-9.835,8.715a2.157,2.157,0,0,1-2.862,0l-9.835-8.715c-9.858-8.714,2.418-21.514,11.266-11.266C934.829,458.575,947.362,472.1,938.408,480.731Z",
    transform: "translate(-912.226 -465.406)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.08f80abb4a82057101a19313166fb3dd.svg";
export { ForwardRef as ReactComponent };